module.exports = __webpack_public_path__ + "img/timbits.e4818aa3.jpg";